<template>
<div v-loading="loading">
<div class="op">
<Candode v-on:childByValue="childByValue" v-on:getTownlength="getTownlength"></Candode>
<div class="idc">
  <el-input v-model="idcard" size="mini" clearable placeholder="请输入推送人身份证号"></el-input>
</div>
<div class="idc">
  <el-button size='mini' type="primary"  @click="searchTel" icon="el-icon-search">搜索</el-button>
</div>
<!-- <div class="idc">
  <el-button size='mini' type="success"  @click="sendAll" icon="el-icon-position" v-show="isSend">全部发送</el-button>
</div> -->
<div class="idc">
  <el-button size='mini' type="success"  @click="sendCheck" icon="el-icon-position" v-show="isSend">发送已选择</el-button>
</div>
</div>
  <el-table
    ref="singleTable"
    highlight-current-row 
    @current-change="handleSelectionChange"
    :data="tableData"
    tooltip-effect="dark"
    style="width: 100%"
    >
    <el-table-column
      type="selection"
      width="55">
    </el-table-column>

    <el-table-column
      label="姓名"
     >
       <template slot-scope="scope">
         {{scope.row.personName?decrypt(scope.row.personName):''}}
         </template>
    </el-table-column>
    <el-table-column
      label="身份证号">
      <template slot-scope="scope">
         {{scope.row.identityNumber?decrypt(scope.row.identityNumber):''}}
         </template>
    </el-table-column>
     <el-table-column
      label="年龄">
      <template slot-scope="scope">
         {{scope.row.lal}}
         </template>
    </el-table-column>
     <el-table-column
      label="手机号">
      <template slot-scope="scope">
         {{scope.row.telphone?decrypt(scope.row.telphone):""}}
         </template>
    </el-table-column>
     <el-table-column
      prop="nowAddress"
      label="所在地区"
      show-overflow-tooltip>
    </el-table-column>
  </el-table>
  <el-pagination
  	class="pone"
      :page-size='10'
      layout="total, prev, pager, next, jumper"
      :total="totals"
      :current-page.sync="Page"
      @current-change="current_change"
>
    </el-pagination>
<el-dialog :modal-append-to-body="false" title="● 推送消息" :visible.sync="dialogFormVisible">
  <div class="conter">
    <el-input
  type="textarea"
  :rows="10"
  placeholder="请输入短信内容"
  v-model="textMsg">
</el-input>
<!-- <el-button class="ps" type="primary" @click="pushmsg">推送</el-button> -->
</div>
  <div slot="footer" class="dialog-footer">
    <el-button @click="dialogFormVisible = false">取 消</el-button>
    <el-button type="primary" @click="pushmsg">推送</el-button>
  </div>
</el-dialog>
</div>
</template>

<style>
.rrr {
  display: flex;
  margin: 20px;
  height: 30px;
  justify-content: space-around;
  align-items: center;
}
.pone {
  margin: 0 !important;
}
.el-cascader-menu__wrap {
  height: 404px !important;
}
.op {
  display: flex;
  align-items: center;
}
.idc {
  margin-left: 10px;
}
.nam {
  margin-right: 20px;
}
.ywtyoe {
  width: 200px;
  margin-left: 20px;
}
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}

.el-timeline {
  padding-left: 20px;
}
.add {
  margin-left: 20px;
}
.ps {
  margin: 0 auto;
  display: block;
  width: 200px;
  margin-top: 10px;
}
.pone {
  text-align: center;
}
</style>

<script>
import Axios from "axios";
import Cookies from "js-cookie";
import CryptoJS from "crypto-js";
import { Loading } from "element-ui";
import { listtown } from "../../utils/address";
import { baseUrl2 } from "../../utils/global";
import defaultImg from "../../assets/defaultPicture.jpg";
import Candode from "../Core/candode";
import { decryptByDES, decrypt } from "../../utils/cypto";
import { formatDate } from "../../utils/datetime";
import { getType } from "../../utils/typeAuth";
import baseUrl from "../../utils/global";
import KtButton from "@/views/Core/KtButton";
export default {
  components: {
    Candode,
    KtButton
  },
  data() {
    return {
      loading: false,
      dialogFormVisible: false,
      tableData: [],
      multipleSelection: [],
      townList: [],
      idcard: "",
      townlen: 1,
      textMsg: "",
      loading: false,
      totals: 0,
      Page: 1,
      telArray: "",
      isSend: false
    };
  },
  methods: {
    searchTel(s) {
      // const isTown = this.townList[2] ? this.townList[2].split(",")[0] : "";

      // if (!isTown) {
      //   this.$message({
      //     type: "warning",
      //     message: "请选择县/区及以下区域进行操作"
      //   });
      //   return;
      // }
      let d = typeof s;
      if (d == "number") {
        d = s;
      } else {
        d = 1;
      }
      this.loading = true;
      let data = {
        provinceName: this.townList[0] ? this.townList[0].split(",")[1] : "",
        cityName: this.townList[1] ? this.townList[1].split(",")[1] : "",
        countryName: this.townList[2] ? this.townList[2].split(",")[1] : "",
        townName: this.townList[3] ? this.townList[3].split(",")[1] : "",
        pageNum: d,
        pageSize: 10,
        bak02: this.idcard ? this.Encrypt(this.idcard) : ""
      };
      this.$api.getlist
        .eightyTel(data)
        .then(res => {
          this.loading = false;
          if (res.code == 200) {
            this.tableData = res.data.list;
            this.totals = res.data.page.total_count;
            this.isSend = true;
          } else {
            this.$message({
              type: "waring",
              message: res.message
            });
            this.tableData = [];
          }
        })
        .catch(err => {
          this.loading = false;
        });
    },
    current_change(s) {
      this.searchTel(s);
    },
    sendAll() {
      this.telArray = "";
      this.pushmsg(); //this.dialogFormVisible=true
    },
    sendCheck() {
      if (this.multipleSelection.length == 0) {
        this.$message({
          type: "warning",
          message: "请至少选择一个人推送！"
        });
        return;
      }
      let arr = [];
      console.log(this.multipleSelection);
      // for(let i in this.multipleSelection){
      //   arr.push({
      //      telphone:this.multipleSelection[i].telphone,
      //      idCard:this.multipleSelection[i].identityNumber,
      //      personName:this.multipleSelection[i].personName
      //   })
      // }
      arr.push(this.multipleSelection);
      this.telArray = arr;
      this.pushmsg(); // this.dialogFormVisible=true
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    strReplace(msg) {
      let str = getType(msg);
      return str;
    },
    formatDate: formatDate,
    childByValue(val) {
      this.townList = val;
      // this.serchCode()
    },
    getTownlength(val) {
      this.townlen = val;
    },
    pushmsg() {
      this.$confirm(
        "此操作将发送" +
          (this.telArray ? this.multipleSelection.length : this.totals) +
          "条短信, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          this.push();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消发送"
          });
        });
    },
    push() {
      let params = {
        provinceName: this.townList[0] ? this.townList[0].split(",")[1] : "",
        cityName: this.townList[1] ? this.townList[1].split(",")[1] : "",
        countryName: this.townList[2] ? this.townList[2].split(",")[1] : "",
        townName: this.townList[3] ? this.townList[3].split(",")[1] : "",
        msgType: 1001,
        adminName: sessionStorage.getItem("user"),
        content: this.textMsg,
        ageCrossUsers: this.telArray ? JSON.stringify(this.telArray) : "",
        bak02: this.idcard ? this.Encrypt(this.idcard) : ""
      };
      this.loading = true;
      this.$api.getlist
        .ageMessage(params)
        .then(res => {
          this.loading = false;
          if (res.code == 200) {
            this.dialogFormVisible = false;
            this.$message({
              message: res.message,
              type: "success"
            });
            this.searchTel(this.Page);
          } else {
            this.$message({
              message: res.message,
              type: "warning"
            });
          }
        })
        .catch(err => {
          this.loading = false;
          this.$message({
            message: "请求失败",
            type: "wraning"
          });
        });
    },
    Encrypt(word) {
      //aes加密
      var key = CryptoJS.enc.Utf8.parse("abcdtnfo23255625");
      let srcs = CryptoJS.enc.Utf8.parse(word);
      let encrypted = CryptoJS.AES.encrypt(srcs, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      });
      return encrypted.toString();
    },
    decrypt(word) {
      var key = CryptoJS.enc.Utf8.parse("abcdtnfo23255625");
      var decrypt = CryptoJS.AES.decrypt(word, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      });
      return CryptoJS.enc.Utf8.stringify(decrypt).toString();
    },
    decryptDes(message) {
      var keyHex = CryptoJS.enc.Utf8.parse("abcdtnfo23255625");
      var decrypted = CryptoJS.DES.decrypt(
        {
          ciphertext: CryptoJS.enc.Hex.parse(message)
        },
        keyHex,
        {
          mode: CryptoJS.mode.ECB,
          padding: CryptoJS.pad.Pkcs7
        }
      );
      return decrypted.toString(CryptoJS.enc.Utf8);
    }
  },
  mounted() {},
  created() {}
};
</script>



// WEBPACK FOOTER //
// src/views/Myvue/agePush.vue